import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class CartsApi extends Api {
  readonly url = "/v2/carts";

  constructor($axios: Context["$axios"]) {
    super("cartService", $axios);
  }

  async postCheckout({ cartId }: PostCartCheckoutParams) {
    return await this.request<OneCheckoutResponse>({
      method: "POST",
      url: `${this.url}/${cartId}/checkout`,
    });
  }
}
